<template>
  <div class="welcome">
    <div class="youtube-video">
      <iframe src="https://www.youtube.com/embed/8nJON6B0xFU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
      </iframe>
      <p>Click here to continue...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Welcome"
}
</script>

<style scoped>

</style>